const checkInLogsMock = [
    {
        id: 1,
        user_id: 101,
        ee_id: 400,
        attendance_shift_id: 1,
        worker: { id: 101, name: "Hans", surname: "Mueller" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "18 m from exhibition, allowed radius 50 m",
        latitude: 51.339642,
        longitude: 12.371304,
        accuracy: 12.4,
        device_uuid: "and-a8f3-91bd",
        platform: "android",
        ip: "91.64.18.21",
        user_agent: "Android Chrome",
        created_at: "2026-05-30 07:12:44",
    },
    {
        id: 2,
        user_id: 101,
        ee_id: 400,
        attendance_shift_id: 1,
        worker: { id: 101, name: "Hans", surname: "Mueller" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        action: "check_out",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339681,
        longitude: 12.371248,
        accuracy: 16.8,
        device_uuid: "and-a8f3-91bd",
        platform: "android",
        ip: "91.64.18.21",
        user_agent: "Android Chrome",
        created_at: "2026-05-30 12:18:09",
    },
    {
        id: 3,
        user_id: 101,
        ee_id: 400,
        attendance_shift_id: 2,
        worker: { id: 101, name: "Hans", surname: "Mueller" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339629,
        longitude: 12.371286,
        accuracy: 14.1,
        device_uuid: "and-a8f3-91bd",
        platform: "android",
        ip: "91.64.18.21",
        user_agent: "Android Chrome",
        created_at: "2026-05-30 13:02:11",
    },
    {
        id: 4,
        user_id: 101,
        ee_id: 400,
        attendance_shift_id: 2,
        worker: { id: 101, name: "Hans", surname: "Mueller" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        action: "check_out",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339583,
        longitude: 12.371421,
        accuracy: 10.8,
        device_uuid: "and-a8f3-91bd",
        platform: "android",
        ip: "91.64.18.21",
        user_agent: "Android Chrome",
        created_at: "2026-05-30 17:46:18",
    },
    {
        id: 5,
        user_id: 102,
        ee_id: 400,
        attendance_shift_id: 3,
        worker: { id: 102, name: "Anna", surname: "Schneider" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "31 m from exhibition, allowed radius 50 m",
        latitude: 51.339718,
        longitude: 12.371018,
        accuracy: 18.7,
        device_uuid: "ios-71c2-44ef",
        platform: "ios",
        ip: "80.187.99.14",
        user_agent: "iOS Safari",
        created_at: "2026-05-30 07:25:19",
    },
    {
        id: 6,
        user_id: 102,
        ee_id: 400,
        attendance_shift_id: 3,
        worker: { id: 102, name: "Anna", surname: "Schneider" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        action: "check_out",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339662,
        longitude: 12.371161,
        accuracy: 22.3,
        device_uuid: "ios-71c2-44ef",
        platform: "ios",
        ip: "80.187.99.14",
        user_agent: "iOS Safari",
        created_at: "2026-05-30 12:05:10",
    },
    {
        id: 7,
        user_id: 102,
        ee_id: 400,
        attendance_shift_id: 4,
        worker: { id: 102, name: "Anna", surname: "Schneider" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339614,
        longitude: 12.371203,
        accuracy: 20.2,
        device_uuid: "ios-71c2-44ef",
        platform: "ios",
        ip: "80.187.99.14",
        user_agent: "iOS Safari",
        created_at: "2026-05-30 12:45:02",
    },
    {
        id: 8,
        user_id: 102,
        ee_id: 400,
        attendance_shift_id: 4,
        worker: { id: 102, name: "Anna", surname: "Schneider" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        action: "check_out",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339512,
        longitude: 12.371225,
        accuracy: 15.2,
        device_uuid: "ios-71c2-44ef",
        platform: "ios",
        ip: "80.187.99.14",
        user_agent: "iOS Safari",
        created_at: "2026-05-30 18:02:31",
    },
    {
        id: 9,
        user_id: 103,
        ee_id: 400,
        attendance_shift_id: 5,
        worker: { id: 103, name: "Lukas", surname: "Fischer" },
        subcontractor: { id: 13, title: "Leipzig Montage GmbH" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339606,
        longitude: 12.371288,
        accuracy: 24.1,
        device_uuid: "web-0d42-9f01",
        platform: "web",
        ip: "178.12.144.62",
        user_agent: "Windows Chrome",
        created_at: "2026-05-31 06:44:08",
    },
    {
        id: 10,
        user_id: 104,
        ee_id: 400,
        attendance_shift_id: 6,
        worker: { id: 104, name: "Svenja", surname: "Krause" },
        subcontractor: { id: 14, title: "Elektro Schmidt GmbH" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "35 m from exhibition, allowed radius 50 m",
        latitude: 51.339744,
        longitude: 12.371119,
        accuracy: 34.6,
        device_uuid: "and-3b90-77ac",
        platform: "android",
        ip: "46.114.51.90",
        user_agent: "Android Chrome",
        created_at: "2026-05-31 06:58:33",
    },
    {
        id: 11,
        user_id: 104,
        ee_id: 400,
        attendance_shift_id: 6,
        worker: { id: 104, name: "Svenja", surname: "Krause" },
        subcontractor: { id: 14, title: "Elektro Schmidt GmbH" },
        action: "check_out",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339701,
        longitude: 12.371071,
        accuracy: 41.3,
        device_uuid: "and-3b90-77ac",
        platform: "android",
        ip: "46.114.51.90",
        user_agent: "Android Chrome",
        created_at: "2026-05-31 16:35:40",
    },
    {
        id: 12,
        user_id: 105,
        ee_id: 400,
        attendance_shift_id: 7,
        worker: { id: 105, name: "Tobias", surname: "Richter" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339934,
        longitude: 12.370844,
        accuracy: 28.9,
        device_uuid: "ios-55e1-220f",
        platform: "ios",
        ip: "80.187.100.42",
        user_agent: "iOS Safari",
        created_at: "2026-05-31 07:08:55",
    },
    {
        id: 13,
        user_id: 105,
        ee_id: 400,
        attendance_shift_id: 7,
        worker: { id: 105, name: "Tobias", surname: "Richter" },
        subcontractor: { id: 11, title: "Messe Bau GmbH" },
        action: "check_in",
        result: "ignored",
        reason: "duplicate_scan",
        detail: "Second check-in scan within 2 minutes",
        latitude: 51.339928,
        longitude: 12.370861,
        accuracy: 29.4,
        device_uuid: "ios-55e1-220f",
        platform: "ios",
        ip: "80.187.100.42",
        user_agent: "iOS Safari",
        created_at: "2026-05-31 07:10:21",
    },
    {
        id: 14,
        user_id: 106,
        ee_id: 400,
        attendance_shift_id: 8,
        worker: { id: 106, name: "Klara", surname: "Hoffmann" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        action: "check_in",
        result: "accepted",
        reason: "within_radius",
        detail: "10 m from exhibition, allowed radius 50 m",
        latitude: 51.339551,
        longitude: 12.371354,
        accuracy: 9.5,
        device_uuid: "and-ff02-135c",
        platform: "android",
        ip: "37.201.88.73",
        user_agent: "Android Firefox",
        created_at: "2026-06-01 06:37:24",
    },
    {
        id: 15,
        user_id: 106,
        ee_id: 400,
        attendance_shift_id: 8,
        worker: { id: 106, name: "Klara", surname: "Hoffmann" },
        subcontractor: { id: 12, title: "Logistics Team A" },
        action: "check_out",
        result: "accepted",
        reason: "within_radius",
        detail: "Within allowed radius",
        latitude: 51.339498,
        longitude: 12.371318,
        accuracy: 11.1,
        device_uuid: "and-ff02-135c",
        platform: "android",
        ip: "37.201.88.73",
        user_agent: "Android Firefox",
        created_at: "2026-06-01 15:59:12",
    },
    {
        id: 16,
        user_id: 107,
        ee_id: 400,
        attendance_shift_id: null,
        worker: { id: 107, name: "Nico", surname: "Weber" },
        subcontractor: { id: 15, title: "Expo Service Nord" },
        action: "check_in",
        result: "rejected",
        reason: "outside_radius",
        detail: "980 m from exhibition, allowed radius 50 m",
        latitude: 51.345802,
        longitude: 12.383112,
        accuracy: 55.2,
        device_uuid: "and-20dc-a448",
        platform: "android",
        ip: "46.114.52.18",
        user_agent: "Android Chrome",
        created_at: "2026-06-01 06:49:11",
    },
    {
        id: 17,
        user_id: 108,
        ee_id: 400,
        attendance_shift_id: null,
        worker: { id: 108, name: "Miriam", surname: "Vogel" },
        subcontractor: { id: 16, title: "Event Technik Leipzig" },
        action: "check_in",
        result: "rejected",
        reason: "permission_denied",
        detail: "Browser location permission was denied",
        latitude: null,
        longitude: null,
        accuracy: null,
        device_uuid: "web-f3b8-901c",
        platform: "web",
        ip: "178.12.144.88",
        user_agent: "Windows Chrome",
        created_at: "2026-06-01 07:03:58",
    },
];

export default checkInLogsMock;
